import React, { useState, useEffect } from 'react';
import './Slideshow.css';

const Slideshow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
      const slides = [
        {
          id: 1,
          title: "TrackCal AI",
          subtitle: "The instant calorie tracking app.",
          description: "Coming soon to the App Store",
          image: "blue",
          cta: "Download on App Store",
          showPhone: true
        }
      ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const slideIndex = Math.floor(scrollPosition / windowHeight);
      setCurrentSlide(Math.min(slideIndex, slides.length - 1));
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [slides.length]);


  return (
    <div className="vertical-slideshow">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`vertical-slide ${index === currentSlide ? 'active' : ''} ${slide.showPhone ? 'phone-slide' : ''} ${slide.image === 'blue' ? 'blue-slide' : ''}`}
          style={{
            backgroundColor: slide.image === 'blue' ? '#9cc7f5' : (slide.image === 'black' ? '#000000' : 'transparent'),
            backgroundImage: (slide.image !== 'blue' && slide.image !== 'black') ? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${slide.image})` : 'none'
          }}
        >
          <div className="slide-content">
                <div className={slide.showPhone ? 'text-content-with-phone' : ''}>
                  <img src="/trackcal-logo.svg" alt="TrackCal AI" className="trackcal-logo" />
                  <h2 className="slide-subtitle">{slide.subtitle}</h2>
                  <p className="slide-description">{slide.description}</p>
                  <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer" className="app-store-link">
                    <img src="/appstore.svg" alt="Download on App Store" className="app-store-icon" />
                  </a>
                </div>
            {slide.showPhone && (
              <div className="phone-mockup">
                <img 
                  src="/IMG_2262-portrait.png" 
                  alt="iPhone Mockup" 
                  className="iphone-image"
                />
              </div>
            )}
          </div>
        </div>
      ))}

    </div>
  );
};

export default Slideshow;
